<div *ngIf="title" class="-heading">
	<h4>{{ title }}</h4>
	<span>{{ subtitle }}</span>
</div>
<div class="-links">
  <ng-container *ngFor="let dropdownLink of dropdownTo">
    <app-link [to]="'/' + dropdownLink.path">
	<lucide-icon [name]="dropdownLink.icon" *ngIf="dropdownLink.icon"></lucide-icon>
	<span>{{dropdownLink.title}}</span>
	</app-link>
  </ng-container>
</div>